import React, { Component } from "react";
import axios from "axios";

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      sending: false,
      formData: this.getDefaultFormData(props.form.formFields),
      invalidElements: []
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  getDefaultFormData(fields) {
    let formData = {};
    fields.map(field => {
      formData[field.fieldName.toLowerCase()] = "";
    });
    return formData;
  }

  getRequiredInputs(form) {
    return Array.from(
      form.querySelectorAll("input,textarea,select,radio,checkbox")
    ).filter(input => {
      const type = input.getAttribute("type");

      const required = input.hasAttribute("required");
      const isSubmitOrHidden = ["submit", "hidden"].indexOf(type) >= 0;
      return required && !isSubmitOrHidden;
    });
  }

  validate() {
    const form = this.form;
    const inputs = this.getRequiredInputs(form);
    let isFormValid = true;
    let invalidElements = [];

    inputs.forEach(input => {
      const type = input.getAttribute("type") || input.nodeName.toLowerCase();
      switch (type) {
        case "select":
        case "textarea":
        case "text":
          if (input.value === "") {
            invalidElements.push(input.getAttribute("name"));
          }
          break;
        case "email":
          if (
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
              input.value
            ) === false
          ) {
            invalidElements.push(input.getAttribute("name"));
          }
          break;
      }
    });
    this.invalidElements = invalidElements;
    isFormValid = invalidElements.length === 0;
    return isFormValid;
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.validate()) {
      this.setState({ ...this.state, invalidElements: this.invalidElements });
      return;
    }

    //console.log(this.state.formData);

    axios
      .post(
        `https://www.miniheroes.com`,
        encode({ "form-name": this.props.form.slug, ...this.state.formData }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      )
      .then(r => {
        this.setState({ ...this.state, sending: false, submitted: true });
      })
      .catch(e => {
        console.log(e);
      });
    this.setState({ ...this.state, sending: true });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const errorElements = [...this.state.invalidElements];

    if (errorElements.indexOf(name) >= 0) {
      errorElements.splice(errorElements.indexOf(name), 1);
      this.setState({
        ...this.state,
        formData: { ...this.state.formData, [name]: value },
        invalidElements: errorElements
      });
    } else {
      this.setState({
        ...this.state,
        formData: { ...this.state.formData, [name]: value }
      });
    }
  }

  formatPhoneNumber = pn => {
    return pn.split(".").join("-");
  };

  // rendering
  renderInfo({ email, phoneNumber }) {
    if (email || phoneNumber) {
      if (email && phoneNumber) {
        return (
          <div className="has-form-info">
            <a className="is-email" href={`mailto:${email}`} target="_blank">
              {email}
            </a>
            <span className="is-phone-number">
              {this.formatPhoneNumber(phoneNumber)}
            </span>
          </div>
        );
      } else if (email) {
        return (
          <div className="has-form-info">
            <a className="is-email" href={`mailto:${email}`} target="_blank">
              {email}
            </a>
          </div>
        );
      } else {
        return (
          <div className="has-form-info">
            <span className="is-phone-number">{phoneNumber}</span>
          </div>
        );
      }
    }
    return null;
  }

  renderSelectOptions(field) {
    const opts = field.selectBoxOptions.split(",");
    let optsList = opts.map(option => {
      return (
        <option key={`${field.id}-${option}`} value={option}>
          {option}
        </option>
      );
    });

    return optsList;
  }

  renderSelectStringOptions(field) {
    const opts = field.selectBoxOptions.split(",");
    let optsList = opts.map(option => {
      const val = option.trim();
      return `<option value="${val}">${val}</option>`;
    });
    optsList.unshift(`<option value="">${field.placeholderText}</option>`);
  }

  renderInput(field) {
    const errorClass =
      this.state.invalidElements.indexOf(field.fieldName) >= 0
        ? " is-invalid"
        : "";
    switch (field.fieldType) {
      case "text":
        return (
          <input
            name={field.fieldName.toLowerCase()}
            className={`input is-medium input-${field.fieldType}${errorClass}`}
            type="text"
            placeholder={field.placeholderText}
            onChange={this.handleInputChange}
            value={this.state.formData[field.fieldName.toLowerCase()]}
            required={field.required || null}
          />
        );
        break;
      case "email":
        return (
          <input
            name={field.fieldName.toLowerCase()}
            className={`input is-medium input-${field.fieldType}${errorClass}`}
            type="email"
            placeholder={field.placeholderText}
            onChange={this.handleInputChange}
            value={this.state.formData[field.fieldName.toLowerCase()]}
            required={field.required || null}
          />
        );
        break;
      case "paragraph":
        return (
          <textarea
            name={field.fieldName.toLowerCase()}
            className={`textarea is-medium input-${
              field.fieldType
            }${errorClass}`}
            placeholder={field.placeholderText}
            onChange={this.handleInputChange}
            value={this.state.formData[field.fieldName.toLowerCase()]}
            required={field.required || null}
          />
        );
        break;
      case "dropdown":
        return (
          <span className={`select is-medium ${errorClass}`}>
            <select
              name={field.fieldName.toLowerCase()}
              className={`input-${field.fieldType}`}
              placeholder={field.placeholderText}
              onChange={this.handleInputChange}
              value={this.state.formData[field.fieldName.toLowerCase()]}
              required={field.required || null}
            >
              {this.renderSelectOptions(field)}
            </select>
          </span>
        );
        break;
    }
  }

  componentDidUpdate() {
    if (this.state.submitted) {
      TweenMax.to(this.overlay, 0.3, { autoAlpha: 1, ease: Sine.easeOut });
    }
  }

  renderStringInput(field) {
    switch (field.fieldType) {
      case "text":
        return `<input name="${field.fieldName.toLowerCase()}" type="text">`;
        break;
      case "email":
        return `<input name="${field.fieldName.toLowerCase()}" type="email">`;
        break;
      case "paragraph":
        return `<textarea name="${field.fieldName.toLowerCase()}"></textarea>`;
        break;
      case "dropdown":
        return `<select name="${field.fieldName.toLowerCase()}">
                    ${this.renderSelectStringOptions(field)}
                </select>`;
        break;
    }
  }

  capitalize(str) {
    return `${str.charAt(0).toUpperCase()}${str.substr(1)}`;
  }

  renderField(field) {
    const errorClass =
      this.state.invalidElements.indexOf(field.fieldName) >= 0
        ? " is-showing"
        : " is-hidden";
    return (
      <div key={field.id} className="field">
        <div className="is-field-info">
          <label className="label is-pulled-left">
            {this.capitalize(field.fieldLabel || field.fieldName)}
            {`${field.required ? "*" : ""}`}
          </label>
          <span
            className={`is-error is-pulled-right has-text-weight-medium ${errorClass}`}
          >
            {field.errorText}
          </span>
        </div>
        <div className="control">{this.renderInput(field)}</div>
      </div>
    );
  }

  getNetlifyForm() {
    const { form } = this.props;
    const {
      title,
      slug,
      introBlurbNode,
      email,
      phoneNumber,
      formFields,
      submitButtonLabel,
      successHeading,
      successBlurbNode
    } = form;

    return `<form novalidate name="${
      form.slug
    }" netlify netlify-honeypot="bot-field" hidden>
            ${formFields.map(field => this.renderStringInput(field)).join("")}
        </form>`;
  }

  render() {
    const { sending, submitted } = this.state;
    const { form } = this.props;
    const {
      title,
      slug,
      introBlurbNode,
      email,
      phoneNumber,
      formFields,
      submitButtonLabel,
      successHeading,
      successBlurbNode
    } = form;

    let fields = [...formFields];
    const hl = Math.ceil(formFields.length / 2);
    const fields1 = fields.splice(0, hl);
    const fields2 = fields;

    return (
      <section className="section has-border-top-mobile">
        <div className="container has-form has-contact-form">
          <div className="columns is-mobile is-multiline">
            <div className="is-4-desktop is-12-mobile column">
              <div className="has-form-intro">
                <div
                  className="content has-text-weight-medium"
                  dangerouslySetInnerHTML={{
                    __html: introBlurbNode.childMarkdownRemark.html
                  }}
                />
                <div className="content has-text-weight-medium">
                  {this.renderInfo({ email, phoneNumber })}
                </div>
              </div>
            </div>
            <div className="is-8-desktop is-12-mobile column">
              {/*<div className="hidden-netlify-form" dangerouslySetInnerHTML={{ __html: this.getNetlifyForm() }} />*/}
              <form
                ref={f => {
                  this.form = f;
                }}
                noValidate
                id={`${form.slug}`}
                name={`${form.slug}`}
                className="is-form is-contact-form"
                onSubmit={this.handleSubmit}
                action="/thanks/"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value={`${form.slug}`} />
                <div className="columns">
                  <div className="column">
                    {fields1.map(field => this.renderField(field))}
                  </div>
                  <div className="column">
                    {fields2.map(field => this.renderField(field))}
                    <div className="control">
                      <button
                        className="button is-primary is-pulled-right"
                        disabled={sending}
                      >
                        {form.submitButtonLabel}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div ref={r => (this.overlay = r)} className="is-submitted-overlay">
            <div className="container">
              <div className="columns is-mobile is-multiline is-centered">
                <div className="is-4-desktop is-10-mobile column has-text-centered">
                  <h2 className="has-text-weight-condensed">
                    {successHeading}
                  </h2>
                  <div
                    className="content has-text-weight-medium"
                    dangerouslySetInnerHTML={{
                      __html: successBlurbNode.childMarkdownRemark.html
                    }}
                  />
                  <div className="content has-text-weight-medium">
                    {this.renderInfo({ email, phoneNumber })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js